import { useVehicleDashboardContext } from "./useVehicleDashboardContext";
import VehicleGallery from "../vehicle-visual-records/VehicleGallery";
import PreparationInfo from "./PreparationInfo";
import VehicleInfo from "./VehicleInfo";
import VehicleMaintenanceGallery from "../vehicle-visual-records/VehicleMaintenanceGallery";
import { Tabs } from "flowbite-react";
import { GoFileDirectoryFill } from "react-icons/go";
import { GoFileDirectory } from "react-icons/go";
import { vehicleTheme } from "./TabsVehicle";
import { CgNotes } from "react-icons/cg";
import { FaMotorcycle } from "react-icons/fa6";
import { VehicleDashboardInformation } from "./VehicleDashboardInformation";
import { FaClipboardList } from "react-icons/fa";
import { VehicleObservations } from "./VehicleObservation";

export function VehicleDashboard() {
  const { vehicle } = useVehicleDashboardContext();

  return (
    <div className="relative flex justify-center w-full h-full overflow-y-auto bg-white dark:bg-white dark:text-black">
      <section className="max-w-7xl w-full p-2">
        <Tabs
          className="tabs-style"
          theme={vehicleTheme}
          aria-label="Default tabs"
        >
          <Tabs.Item
            icon={FaMotorcycle}
            title={<div className="tabs-name-style">Informações</div>}
          >
            <VehicleDashboardInformation />
          </Tabs.Item>

          <Tabs.Item
            icon={FaClipboardList}
            title={<div className="tabs-name-style">Tecnicidades</div>}
          >
            <div className="tabs-border-line">
              <section className="tabs-item-style">
                <PreparationInfo />
              </section>

              <div className="div-tabs-border-line"></div>

              <section className="tabs-item-style">
                <VehicleInfo />
              </section>
            </div>
          </Tabs.Item>

          <Tabs.Item
            icon={GoFileDirectoryFill}
            title={<div className="tabs-name-style">Histórico</div>}
          >
            <VehicleGallery data={vehicle} />
          </Tabs.Item>

          <Tabs.Item
            icon={GoFileDirectory}
            title={<div className="tabs-name-style">Manutenção</div>}
          >
            <VehicleMaintenanceGallery data={vehicle} />
          </Tabs.Item>

          <Tabs.Item
            icon={CgNotes}
            title={<div className="tabs-name-style">Observações</div>}
          >
            <VehicleObservations />
          </Tabs.Item>
        </Tabs>
      </section>
    </div>
  );
}
